export enum Keys {
  BACKSPACE = 8,
  TAB = 9,
  ENTER = 13,
  ESCAPE = 27,
  SPACE = 32,
  LEFT = 37,
  UP = 38,
  RIGHT = 39,
  DOWN = 40,
  DELETE = 46,
  KEY_F2 = 113,

  CARET = 94,
  SEMICOLON = 59,
  HASH = 35,
  AMPERSAND = 38,
  PLUS = 43,
  PIPE = 124,
}
